import React, { useId } from "react";
import FieldWrapper from "./FieldWrapper";

/**
 * Native month input (YYYY-MM) with shared FieldWrapper.
 * Use when you want a simple, compact control that relies on the browser’s native picker.
 * For a custom year/month grid and “current & future disabled” behavior, use MonthPicker instead.
 *
 * @see MonthPicker – custom dropdown with year navigation and optional disableCurrentAndFuture
 */
export default function MonthField({
  label = "Month",
  value = "",
  onChange,
  min,
  max,
  required,
  disabled,
  error,
  showError,
  className = "",
  id: idProp,
}) {
  const generatedId = useId();
  const id = idProp ?? generatedId;
  return (
    <FieldWrapper
      id={id}
      label={label}
      required={required}
      error={error}
      showError={showError}
      className={className}
    >
      <input
        id={id}
        type="month"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        min={min}
        max={max}
        disabled={disabled}
        aria-describedby={showError && error ? `${id}-error` : undefined}
        className="w-full rounded-xl border border-palette-gray-divider px-3 py-2 outline-none
                   focus:ring-2 focus:ring-palette-indigo-border disabled:bg-palette-gray-subtle disabled:text-palette-gray-secondary"
      />
    </FieldWrapper>
  );
}
